import { render, staticRenderFns } from "./reclamos.vue?vue&type=template&id=189a18d0"
import script from "./reclamos.vue?vue&type=script&lang=js"
export * from "./reclamos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports